const cfg = window.webConfig;

const webConfig = {
    Urls: {
        Taxes_Payer: cfg.Urls.Taxes_Payer,
        Taxes_Object: cfg.Urls.Taxes_Object,

        ASAN_Check_Token: cfg.Urls.ASAN_Check_Token,
        ASAN_Login_Page: cfg.Urls.ASAN_Login_Page,
        ASAN_Get_Certs: cfg.Urls.ASAN_Get_Certs,
        ASAN_Logout: cfg.Urls.ASAN_Logout,
        HOME_PAGE: cfg.Urls.HOME_PAGE,
        IndustryCategory: cfg.Urls.IndustryCategory,
        Questionary: cfg.Urls.Questionary,
        QuestionaryResponseCombination: cfg.Urls.QuestionaryResponseCombination,
        Criterias: cfg.Urls.Criterias,
        CriteriaQuestions: cfg.Urls.CriteriaQuestions,
        GradeApplication: cfg.Urls.GradeApplication,
        Stakeholder: cfg.Urls.Stakeholder,
        Translation: cfg.Urls.Translation,
        Notification: cfg.Urls.Notification,
        Socket: cfg.Urls.Socket,
        Region: cfg.Urls.Region,
        Country: cfg.Urls.Country,
        City: cfg.Urls.City
    },
    microserviceNames: {
        taxesMicroserviceProxy: cfg.microserviceNames.taxesMicroserviceProxy,
        asanMicroserviceProxy: cfg.microserviceNames.asanMicroserviceProxy,
        stakeholderMicroserviceWithoutToken: cfg.microserviceNames.stakeholderMicroserviceWithoutToken,
        stakeholderMicroservice: cfg.microserviceNames.stakeholderMicroservice,
        authentication: cfg.microserviceNames.authentication,
        notifications: cfg.microserviceNames.notifications
    },
    auth: {
        roles: cfg.auth.roles,
        institutionVoens: cfg.auth.institutionVoens
    },
    contents: {
        guideAgreement: {
            title: cfg.contents.guideAgreement.title,
            body: cfg.contents.guideAgreement.body,
        },
        tatoAgreement: {
            title: cfg.contents.tatoAgreement.title,
            body: cfg.contents.tatoAgreement.body,
        },
        institutionRegistrationAgreement: {
            title: cfg.contents.institutionRegistrationAgreement.title,
            body: cfg.contents.institutionRegistrationAgreement.body,
        }
    }
}

export default webConfig;